// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__RBtNK","disabled":"Button_disabled__PUkNe","active":"Button_active__y7gJv"};